<template>
  <div class="lisence-bd tb" v-if="funcView.bizTypeRecord_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 配置项 -->
        <el-form-item style="float: right" :class="mr-0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_bizTypeRecord.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <!-- 操作时间 -->
        <el-form-item style="float: right">
          <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"
            :startPlaceholder="$t('dms_bizTypeRecord.bian_geng_shi_jian')"
            :endPlaceholder="$t('dms_bizTypeRecord.bian_geng_shi_jian')"
            @change="onPageChange({ page: 1 })"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" >
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'bizTypeRecord',
  components: {},
  data() {
    return {
      tableCode: 'bizTypeRecord',
      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        oldBodyNum: '',
        oldModemSn: '',
        productCode: '',
        timezone: [],
        timer: '',
        optStartTime: '',
        optEndTime: '',
      },
      tableList: [],
      totalRows: 0,
    };
  },
  mounted: function () {
    this.getTableColumn();

    this.getTableList();
    this.getFuncView();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.optStartTime = this.formSearch.timer && this.formSearch.timer[0] ? this.formSearch.timer[0] : null;
      this.formSearch.optEndTime = this.formSearch.timer && this.formSearch.timer[1] ? this.formSearch.timer[1] : null;
      this.$getJSON(apis.deviceBizTypeChangePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss"></style>
